<form [formGroup]="groupForm">
  <div *ngFor="let criteria of group.commitmentCriterias;" class="commitment-container">
        <span class="commitment-title">
          <mat-icon *ngIf="criteria.template.categoryLevel > 1" class="sublevel-icon">
            subdirectory_arrow_right
          </mat-icon>
          {{ criteria.template.title }}
    </span>
    <div class="commitment-container">
      <div class="tv-square-input-for-date-pickers-small-no-label width-180px disabled-form-field">
        <mat-form-field>
          <input
            matInput
            [value]="criteria.datetimeValue.date"
            [readonly]="!criteria.template.editable || isPastYearContract"
            [matDatepicker]="criteriaTemplateDatepicker"
          />
          <span
            *ngIf="!(group.category === 'baseCategory')"
            matPrefix
            class="commitment-prefix invisible"
          >%</span>
          <!-- <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle> -->
          <!-- <mat-datepicker #criteriaTemplateDatepicker></mat-datepicker> -->
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
